import React, { useEffect, useState } from "react";
import $ from "jquery";
import { textmapping } from "../../helper";

function UploadedImage(props) {
  const [imageUrl, setImageUrl] = useState(props.src);
  const [inputImage, setInputImage] = useState(props.selectedInput);

  console.log("imageurl ", imageUrl);

  useEffect(() => {
    setImageUrl(props.src);
  }, [props.src]);

  let type = props.type;

  let degree = 0;
  // let degree1 = 0;

  const rotateLeft = async () => {
    degree = degree - 90;
    // degree1 = degree1 + 90;
    // console.log('degree1 ', degree1)
    $(".image").css("transform", `rotate(${degree}deg)`);
  };

  const rotateRight = async () => {
    degree = degree + 90;
    // degree1 = degree1 - 90
    // console.log('degree1 ', degree1)
    $(".image").css("transform", `rotate(${degree}deg)`);
  };

  const submitHandler = async (image) => {
    $(".preloader_bg").show();
    let res = "";
    props.close();

    degree = degree % 360;
    // console.log("submit", degree1);
    // if(degree1 !== 0 || degree1 !== -0) {
    //    res = await props.rotateImage(inputImage, degree1)
    // }
    if (type !== "Monuments") {
      if (degree !== 0 || degree !== -0) {
        res = await props.rotateImage(inputImage, degree);
      }

      $(".preloader_bg").hide();
      props.showCropper(res ? res : image);
    }
    if (type === "Monuments") {
      if (degree !== 0 || degree !== -0) {
        res = await props.rotateImage(inputImage, degree);
      }
      console.log("response ", res);
      let response = await props.submitEffect(res ? res : image);
      console.log("response ", response);
      $(".preloader_bg").hide();
    }
  };

  return (
    <>
      <div className="uploadimg_bg">
        <div className="uploadimg_position">
          <img
            src="/assets/images/cross.svg"
            className="crosspopup"
            alt=""
            onClick={props.close}
          />
          <h4 className="text-center">
            {textmapping("Uploaded Image", props.lang)}
          </h4>
          <img
            src={imageUrl}
            alt=""
            width={200}
            height={200}
            className="image"
          />

          <div className="d-flex justify-content-center btn_rotate">
            <button onClick={rotateLeft}>
              <img src="/assets/images/left.svg" alt="" title="rotate left" />
            </button>
            <button onClick={rotateRight}>
              <img src="/assets/images/right.svg" alt="" title="rotate right" />
            </button>
          </div>

          <button
            className="submit_btn"
            onClick={() => submitHandler(imageUrl)}
          >
            {textmapping("Submit", props.lang)}
          </button>
        </div>
      </div>
    </>
  );
}

export default UploadedImage;
